import React, { FC, ReactNode } from 'react';
import { queryClient } from 'src/lib/react-query';
import { CommonProviders } from './common';

export const AppProviders: FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <CommonProviders queryClient={queryClient}>{children}</CommonProviders>
  );
};
